import GeneralActions from './general.actions';

import TypePerturbationRepository from '../repositories/type-perturbation.repository';

export const REQUEST_TYPE_PERTURBATION = 'REQUEST_TYPE_PERTURBATION';
export const RECEIVE_TYPE_PERTURBATION = 'RECEIVE_TYPE_PERTURBATION';
export const FAILURE_TYPE_PERTURBATION = 'FAILURE_TYPE_PERTURBATION';

function failureTypePerturbation() {
  return {
    type: FAILURE_TYPE_PERTURBATION,
    payload: {}
  };
}

function receiveTypePerturbation(data) {
  return {
    type: RECEIVE_TYPE_PERTURBATION,
    payload: {
      data
    }
  };
}

function requestTypePerturbation() {
  return {
    type: REQUEST_TYPE_PERTURBATION,
    payload: {}
  };
}

function loadData() {
  return (dispatch, getState) => {
    if (getState().typePerturbation.fetching || getState().typePerturbation.data) {
      // Chargement en cours ou on a des données, on ne fait rien
      return;
    }
    dispatch(GeneralActions.taskStarted());
    dispatch(requestTypePerturbation());
    TypePerturbationRepository.load()
      .then((response) => {
        dispatch(GeneralActions.taskDone());
        dispatch(receiveTypePerturbation(response.data));
      }, () => {
        dispatch(GeneralActions.taskFailed());
        dispatch(failureTypePerturbation());
      });
  };
}

export default {
  loadData
};



// WEBPACK FOOTER //
// ./src/actions/type-perturbation.actions.js